/**
 * Máscara de valor em R$ no estilo do cadastro de produto:
 * o usuário digita só dígitos e a vírgula (centavos) entra sozinha.
 *
 * Ex.: "4" → "R$ 0,04" · "400" → "R$ 4,00" · "12345" → "R$ 123,45"
 */

/** Formata input digitado (só dígitos) como moeda BRL. */
export function formatCurrencyInputBR(v) {
  const onlyDigits = String(v ?? '').replace(/\D/g, '');
  if (!onlyDigits) return '';
  const number = Number(onlyDigits) / 100;
  if (!Number.isFinite(number)) return '';
  return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/** Converte número (ou string numérica) para display BRL. */
export function formatBRLFromNumber(n) {
  if (n === null || n === undefined || n === '') return '';
  const num = Number(n);
  if (!Number.isFinite(num)) return '';
  return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/**
 * Converte string BRL (ou decimal com vírgula) para number.
 * Retorna null se vazio/inválido.
 */
export function parseBRLToNumber(str) {
  if (str === '' || str == null) return null;
  if (typeof str === 'number') return Number.isFinite(str) ? str : null;
  const normalized = String(str)
    .replace(/[R$\s]/g, '')
    .replace(/\./g, '')
    .replace(',', '.');
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}

/** Atalho: parseBRLToNumber com fallback 0. */
export function parseBRLToNumberOrZero(str) {
  return parseBRLToNumber(str) ?? 0;
}

/** Campos monetários do item NF-e (comercial + tributos). */
export const NFE_ITEM_MOEDA_KEYS = [
  'vUnCom', 'vDesc', 'vOutro', 'vIPIDevol', 'vTotTrib',
  'vBc', 'vIcms', 'vCredIcmsSn', 'vBcSt', 'vIcmsSt',
  'vFcp', 'vFcpSt',
  'vBcUfDest', 'vFcpUfDest', 'vIcmsUfDest', 'vIcmsUfRemet',
  'vBcIpi', 'vIpi', 'vBcPis', 'vPis', 'vBcCofins', 'vCofins',
];

/** Converte número ou string numérica para exibição no input de moeda. */
export function toMoedaInput(v) {
  if (v === '' || v == null) return '';
  const parsed = parseBRLToNumber(v);
  const n = parsed ?? (typeof v === 'number' ? v : Number(String(v).replace(',', '.')));
  if (!Number.isFinite(n) || n === 0) return '';
  return formatBRLFromNumber(n);
}

/** Formata campos monetários de um item NF-e para edição na tela. */
export function formatNfeItemMoedaForDisplay(item) {
  const next = { ...item };
  NFE_ITEM_MOEDA_KEYS.forEach((key) => {
    next[key] = toMoedaInput(item[key]);
  });
  return next;
}

/** Converte campos monetários de um item NF-e para número antes de salvar. */
export function parseNfeItemMoedaForSave(item) {
  const next = { ...item };
  NFE_ITEM_MOEDA_KEYS.forEach((key) => {
    if (next[key] === '' || next[key] == null) {
      next[key] = key === 'vUnCom' ? 0 : (key === 'vDesc' || key === 'vOutro' ? 0 : '');
      return;
    }
    next[key] = parseBRLToNumberOrZero(next[key]);
  });
  return next;
}
